/**
 * @typedef {Object} RailConfig
 * @property {string} width - The width of the rail.
 * @property {function} useGuard - the guard function to determine if the rail should be displayed.
 * @property {boolean} closeOnNavigation - Determines if the rail should be closed when navigating.
 * @property {React.ComponentType} component - The React component to render in the rail.
 * @typedef {Object.<string, RailConfig>} Rails - A mapping of string keys to rail configurations.
 */
import { useSelector } from 'react-redux'

import { isOnFreeStageSelector, isOnTrialStageSelector, isOnPaidStageSelector } from 'features/billing'

import { ExampleShareAvailability, ShareAvailability, BookMeeting, ExampleBookMeeting, SendEmail, ExampleSendEmail } from './lazy'
import { SHAREABLE_ROUTE_PLACEMENTS } from './placement'

const useCanSeePaidTrialActions = () => {
  const isPaidCustomer = useSelector(isOnPaidStageSelector)
  const isTrialCustomer = useSelector(isOnTrialStageSelector)
  const isFreeCustomer = useSelector(isOnFreeStageSelector)

  return !isFreeCustomer && (isPaidCustomer || isTrialCustomer)
}

/**
 * Rails configuration object.
 * @type {Rails}
 */
export const routes = {
  // Examples
  example_share_availability: {
    component: ExampleShareAvailability,
    closeOnNavigation: true
  },
  example_book_meeting: {
    component: ExampleBookMeeting,
    closeOnNavigation: true
  },
  example_send_email: {
    component: ExampleSendEmail,
    closeOnNavigation: true
  },
  share_availability: {
    component: ShareAvailability,
    closeOnNavigation: true,
    placement: SHAREABLE_ROUTE_PLACEMENTS.share_availability,
    useGuard: () => useCanSeePaidTrialActions()
  },
  book_meeting: {
    component: BookMeeting,
    closeOnNavigation: true,
    placement: SHAREABLE_ROUTE_PLACEMENTS.book_meeting
  },
  send_email: {
    component: SendEmail,
    closeOnNavigation: true
  },
}
